module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3036617078/src/src/app/common/auto-logout/auto-logout.component.html
// module id = ../../../../../src/app/common/auto-logout/auto-logout.component.html
// module chunks = main